import { onMounted, onBeforeUnmount } from 'vue'

export function useDragScroll(containerRef, { speed = 1 } = {}) {
  let isDown = false
  let startX = 0
  let scrollLeft = 0
  let dragDistance = 0

  const onPointerDown = (e) => {

    // return;
    if (e.button !== 0) return

    const el = containerRef.value
    if (!el) return

    isDown = true
    dragDistance = 0
    startX = e.clientX
    scrollLeft = el.scrollLeft

    el.style.cursor = 'grabbing'
    // el.setPointerCapture(e.pointerId)
  }

  const onPointerMove = (e) => {
    if (!isDown) return

    const el = containerRef.value
    if (!el) return

    const dx = e.clientX - startX
    dragDistance = Math.abs(dx)

    el.scrollLeft = scrollLeft - dx * speed
  }

  const onPointerLeave = () => {
    const el = containerRef.value
    if (!el) return

    isDown = false
    dragDistance = 0
    el.style.cursor = 'grab'
  }

  const onPointerUp = (e) => {
    const el = containerRef.value
    if (!el) return

    if (e.pointerType !== 'mouse') return
    isDown = false

    if (dragDistance > 0) {
        const cancelClick = (event) => {
          event.preventDefault()
          event.stopPropagation()
          el.removeEventListener('click', cancelClick, true)
        }
        el.addEventListener('click', cancelClick, true)
      }

      dragDistance = 0;
  }

  const disableNativeDrag = (e) => {
    e.preventDefault()
  }

  onMounted(() => {
    if (!window.PointerEvent) return;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return
    }

    const el = containerRef.value
    if (!el) return

    el.style.cursor = 'grab'
    el.style.userSelect = 'none'
    el.style.touchAction = 'pan-y'

    el.addEventListener('pointerdown', onPointerDown)
    el.addEventListener('pointermove', onPointerMove)
    el.addEventListener('pointerup', onPointerUp)
    el.addEventListener('pointerleave', onPointerLeave)
    el.addEventListener('dragstart', disableNativeDrag)
  })

  onBeforeUnmount(() => {
    const el = containerRef.value
    if (!el) return
    el.removeEventListener('pointerleave', onPointerLeave)
    el.removeEventListener('pointerdown', onPointerDown)
    el.removeEventListener('pointermove', onPointerMove)
    el.removeEventListener('pointerup', onPointerUp)
  })
}